module.exports = __webpack_public_path__ + "img/uc-new.20d1042.png";